import { render, staticRenderFns } from "./stationDic.vue?vue&type=template&id=3ffbda27"
import script from "./stationDic.vue?vue&type=script&lang=js"
export * from "./stationDic.vue?vue&type=script&lang=js"
import style0 from "./stationDic.vue?vue&type=style&index=0&id=3ffbda27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports